import { Box, InfoDot, Text } from '@factorialco/deprecated-design-system'
import type { SliceTooltipProps } from '@nivo/line'
import moment from 'moment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { toCents } from 'modules/core/lib/formatCurrencyUtils'
import MoneyWithCurrency from 'modules/core/lib/money'

interface Props extends SliceTooltipProps {
  currency: string
}

const SliceTooltip = (tooltipProps: Props) => {
  const slice = tooltipProps.slice
  const point = slice.points[0]!

  const valueX = moment(point.data.x).format('MMMM YYYY')

  const {
    access: { locale },
  } = useCurrentSession()

  const valueY = MoneyWithCurrency({
    amount: Math.floor(toCents(point.data.y as number)),
    currency: tooltipProps.currency,
    locale,
  })
  return (
    <Box
      padding="s12"
      background="grey800"
      borderRadius={{
        all: 'abs008',
      }}
      textAlign="left"
      minWidth="s240"
    >
      <Box gap="s8">
        <Text size="100" weight="normal" color="grey100">
          {valueX}
        </Text>
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" gap="s24">
          <Box flexDirection="row" gap="s8" alignItems="center">
            <InfoDot size="medium" color="viridian1000" />
            <Text size="200" weight="medium" color="grey100">
              {point?.serieId}
            </Text>
          </Box>
          <Text size="100" weight="normal" color="grey100">
            {valueY}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

export default SliceTooltip
